import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

const ArmExpandedRowContainer = styled(TableRow)`
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  box-shadow: 0 7px 6px rgba(0, 0, 0, 0.15);
  transform: translateY(-17px);
  background-color: white;
`;

const ArmExpandedCell = styled(TableCell)`
  padding: 20px;
  font-family: inherit;
`;

const AmpExpandedRow = ({noRows, expandedContent}) => (
  <ArmExpandedRowContainer>
    <ArmExpandedCell colSpan={noRows}>
      {expandedContent}
    </ArmExpandedCell>
  </ArmExpandedRowContainer>
);

AmpExpandedRow.propTypes = {
  noRows: PropTypes.number,
  expandedContent: PropTypes.object
};

export default AmpExpandedRow;

